import React from "react";
import { useDispatch } from "react-redux";
import { setDialog } from "../../../features/dialog/dialogSlice";

function CreateNewDocumentView() {
  const dispatch = useDispatch();

  const openDialog = () => {
    dispatch(
      setDialog({
        title: "Neues Dokument erstellen",
        type: "CREATE",
        content: "create-filedata",
        redirect: "/dashboard/files",
      })
    );
  };

  React.useEffect(() => {
    openDialog();
  });

  return <div></div>;
}

export default CreateNewDocumentView;
